export const selectTrendFilters = (state) => state.baseTrendFilters;

export const selectTrendFilterFrequency = (state) =>
    state.baseTrendFilters.frequency;
export const selectTrendFilterCompare = (state) =>
    state.baseTrendFilters.compare;
